import { ORGANIZATION_SLUG } from 'service/constants'
import constants from 'constants/index'

// Grava o slug do white-label ao entrar na tela de login, para sobreviver às
// telas de loading de SSO/Microsoft (que voltam em URLs sem o slug real).
// Em slug padrão (dponet) ou ausente, limpa — não há white-label a manter.
const persistSlug = (slug) => {
  const { DEFAULT_SLUGS_PATHS } = constants.settings

  if (!slug || DEFAULT_SLUGS_PATHS.includes(slug?.toLowerCase())) {
    sessionStorage.removeItem(ORGANIZATION_SLUG)
    return
  }

  sessionStorage.setItem(ORGANIZATION_SLUG, slug)
}

export default persistSlug
